// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1jg0_","validationTips":"StatementDescriptor_validationTips__2f_u6"};